import React from 'react'
import classnames from 'classnames'

import styles from './hero.module.scss'

export default function Hero({ imageSrc, title, className, titleClassName }) {
  return (
    <div className={classnames(styles.hero, className)}>
      <div
        style={{ backgroundImage: `url(${imageSrc})` }}
        className={styles.heroInner}
      >
        <div className={classnames(styles.title, titleClassName)}>{title}</div>
      </div>
    </div>
  )
}
